module.exports = __webpack_public_path__ + "img/symbol_1.8f6cda1c.png";